// Kiosk Menü Yönetimi sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.kioskMenuPage';

export const kioskMenuPageGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Kiosk Menü Yönetimi nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Bu sayfada işletmenizdeki self servis sipariş kiosklarını tanımlar, durumlarını izler ve her kioskun ayarlarına girersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve düğmeler'),
    stats: t(`${G}.regions.stats`, 'Özet kartları'),
    table: t(`${G}.regions.table`, 'Kiosk listesi'),
    pagination: t(`${G}.regions.pagination`, 'Sayfalama'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Yeni kiosk ekleyin'),
      text: t(`${G}.s1.text`, '"Yeni Kiosk Ekle" düğmesi kiosk ekleme penceresini açar; ad, durum, şube ve ekran boyutunu orada girersiniz. Kayıttan sonra liste kendiliğinden yenilenir.'),
      tips: [
        t(`${G}.s1.tip1`, '"Kiosk Ürünleri" düğmesi, kioskta satışa açık stok ürünlerinin listesine gider.'),
      ],
    },
    {
      region: 'stats',
      title: t(`${G}.s2.title`, '2. Özet kartları'),
      text: t(`${G}.s2.text`, 'Toplam Kiosk, Aktif Kiosk, Bakımda ve Pasif Kiosk kartları kayıtlı kioskların durumlarına göre sayısını gösterir.'),
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Kiosk listesi'),
      text: t(`${G}.s3.text`, 'Her satırda kioskun adı, Durum (Aktif / Pasif / Bakımda), Ekran Boyutu, Şube ve Cihaz Durumu görünür. Şube seçilmemiş kiosklarda "Atanmamış" yazar.'),
      tips: [
        t(`${G}.s3.tip1`, 'Cihaz Durumu: "Bağlı" cihaz çalışıyor, "Kurulum Bekliyor" cihaz eklendi ama henüz giriş yapmadı, "Çevrimdışı" cihaz bağlı değil, "Cihaz Yok" bu kioska cihaz eklenmemiş.'),
        t(`${G}.s3.tip2`, 'Cihaz eklemek ve giriş kodunu almak için ⋮ → Ayarlar → "Cihaz Yönetimi" sekmesini kullanın.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Satır işlemleri (⋮)'),
      text: t(`${G}.s4.text`, 'Satır sonundaki ⋮ menüsünde: "Düzenle" kioskun temel bilgilerini, "Ayarlar" reklam, kategori, ürün, adisyon, yazarkasa, cihaz, ödeme ve mutfak ekranı ayarlarını açar.'),
      tips: [
        t(`${G}.s4.tip1`, '"Cihazları Yeniden Başlat": onaydan sonra bu kioskun şubesindeki kiosk cihazlarına yeniden başlatma isteği gönderilir. Aktif cihazlar kısa süre kullanılamaz; yoğun saatlerde kullanmayın.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Kiosk silme'),
      text: t(`${G}.s5.text`, '⋮ → "Sil" onay ister. Silinen kiosk listeden kalkar; bu işlem geri alınamaz.'),
    },
    {
      region: 'pagination',
      title: t(`${G}.s6.title`, '6. Sayfalama'),
      text: t(`${G}.s6.text`, 'Kiosk çoksa alttan sayfa başına satır sayısını seçip sayfalar arasında geçin.'),
    },
  ],
});
